import PerformancePerTurn from './PerformancePerTurn';

export default PerformancePerTurn;


// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/performancePerTurn/index.js